'use client';

import React, { Component } from 'react';
import './style.sass';

import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';

import Task from '../reusable-components/layouts-components__techliders/task';
import Complex from '../reusable-components/layouts-components__techliders/complex';
import Process from '../reusable-components/layouts-components__techliders/process';
import PortfolioImages from '../reusable-components/layouts-components__techliders/portfolio-Images';
import Results from '../reusable-components/layouts-components__techliders/results';
import Team from '../reusable-components/layouts-components__techliders/team';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import Functional from '../reusable-components/layouts-components__techliders/functional';
import PortfolioGallery from '../reusable-components/layouts-components__techliders/portfolio-gallery';
import OnePicture from '../reusable-components/layouts-components__techliders/one-picture';
import CommonSmallTitle from '../common-components/common-small-title';
import CommonSmallText from '../common-components/common-small-text';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';

const techLeadersMainTitle = {
    titleMainText: `Запустили сложную экосистему ежегодного форума`,
    titleAnimation: '/images/pic/preview/techleaders.png',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#07ddd6',
            nameText: 'АО&nbsp;&laquo;Российская венчурная компания&raquo;',
        },
        {
            modeText: 'Отрасль, инновации',
            colorMode: '#07ddd6',
            nameText: 'Технологии',
        },
        {
            modeText: 'Технологии',
            colorMode: '#07ddd6',
            nameText: 'PHP, Bitrix, React, Sass, БЭМ, Webpack, MySQL',
        },
    ],
};

const nextProjectTechLeaders = {
    nextProjectTitle:
        'Серия сервисов для личного кабинета сайта Корпорации развития Дальнего Востока',
    nextProjectImg: '/images/pic/preview/krdv.png',
    nextProjectLink: '/cases/development/krdv',
    nextProjectLinkTitle: 'Корпорация развития Дальнего Востока',
    nextProjectText:
        'Разработали серию сервисов для системы личных кабинетов представителей юридических лиц, которые не имеют аналогов в России',
};

class TechLeaders extends Component {
    render() {
        return (
            <section className="tech-leaders">
                <MainTitle MainTitle={techLeadersMainTitle}>
                    <CommonSmallTitle className="tech-leaders__subtitle">
                        Глобальное технологическое лидерство
                    </CommonSmallTitle>
                    <CommonSmallText isOneParagraph={false}>
                        Это форум, который посвящен внедрению передовых сквозных технологий
                        в&nbsp;высокотехнологичных отраслях и&nbsp;развитию инновационной экосистемы
                        государства.
                    </CommonSmallText>
                    <CommonSmallText isOneParagraph={false}>
                        Фокус форума&nbsp;&mdash; формирование технологической политики России
                        на&nbsp;следующее десятилетие, оценка результатов научно-технологического
                        развития, определение роли и&nbsp;лидерского потенциала России
                        в&nbsp;мировой технологической повестке и&nbsp;формирование стратегии
                        Национальной технологической инициативы до&nbsp;2025&nbsp;года.
                    </CommonSmallText>
                    <CommonSmallText isOneParagraph={false}>
                        Мероприятия программы форума посвящены формированию горизонтальных связей
                        внутри инновационного технологического сообщества и&nbsp;поиску совместных
                        решений, ускоряющих процесс научно-технологического развития России.
                    </CommonSmallText>
                </MainTitle>

                <Task />

                <Complex />

                <OnePicture />

                <Process />

                <PortfolioImages />

                <Functional />

                <PortfolioGallery />

                <Results />

                <Team />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                <NextProject NextProject={nextProjectTechLeaders} />
            </section>
        );
    }
}

export default TechLeaders;
